module.exports = __webpack_public_path__ + "img/5e3733e.png";